import { useEffect,useState } from 'react';
import { KTIcon } from '../../../../_metronic/helpers';
import axios from 'axios';
import { ViewModal } from './components/ViewModal';
import { useAuth } from '../../auth';
import { useAppSelector } from '../../../../redux/hooks';
import Popup from './components/popup';
 
const API_URL = process.env.REACT_APP_API_URL
 
type ID = undefined | null | number
 
type record=
{
    id: any,
    type: any,
    subject: any,
    suscription: any,
    priority: any
    status:
    {
     label: any
     label_for_customers:any
    }
}
 
function TicketsCrud() {
    const{currentUser}= useAuth()
 
    /* variable para el modal  */
    const [ ID , setID]=useState<ID>(undefined)
    const tenant= useAppSelector(state =>state.TenantSlice.id)
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
 
 
    /*************************** CONSTANTES ***************************************/
 
    //const [Tickets,setTickets]=useState([])
    const [records,setRecords]= useState<record[]>([])
    /**********************Llamada a axios y parse de data**********************/
    useEffect( () => {
        if (currentUser?.ListPermiso?.includes('Support.List')){
        if (tenant===0){
            axios.get(API_URL+'/v1/support/')
            .then(res=>{
                setRecords(res.data)
            })
        }
        else{
            axios.get(API_URL+'/v1/support/?tenantId='+tenant)
            .then(res=>{
                setRecords(res.data)
            })
        }
        }
     }, [tenant])
 
       
 
     /***********************************************************************************/
        const [showPopup, setShowPopup] = useState(false);
        const [popupText, setPopupText] = useState('');
        const [cellIndex, setCellIndex] = useState<number | null>(null);
 
        const handleMouseEnter = (text: string, index: number) => {
            setPopupText(text);
            setCellIndex(index);
            setShowPopup(true);
          };
 
        const handleMouseLeave = () => {
            setShowPopup(false);
        };
    /******************************************************************************** */
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = records.slice(indexOfFirstRecord, indexOfLastRecord);
 
    const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
 
    const handleRecordsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setRecordsPerPage(parseInt(e.target.value));
        setCurrentPage(1); // Para volver a la primera página cuando se cambia la cantidad de registros por página
    };
 
    return(
        <>
        <div className='card'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column '>
            <span className='f-titulo text-marino fs-md'>Tickets</span>
            </h3>
            {/*Se agrega Boton para agregar usuarios*/}
           {/*<Link style={{marginRight:'15px'}}to="/create" className='btn btn-primary'>Add Nex User</Link>*/}
        </div>
 
        {/* end::Header */}
 
        {/* begin::Body */}
        <div className='card-body py-3'>
            <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                {/* begin::Table container */}
                <div className='table-responsive'>
 
                {/* begin::Table */}
                    <table className='w-full f-parrafo  caption-bottom  custom-table' id='table'>
                        {/* begin::Table head */}
                        <thead>
                           
                            <tr className='table-header-light bg-marino'>
                                <th className='table-cell'>Type</th>
                                <th className='table-cell'>Ticket Number</th>
                                <th className='table-cell'>Title</th>
                                <th className='table-cell'>Status</th>
                                <th className='table-cell'>Priority</th>
                                <th className='table-cell'>Details</th>
                            </tr>
                        </thead>
                        {/* end::Table head */}
 
 
                        {/* begin::Table body */}
                       <tbody>
                            {
                                currentRecords?.map((d,i)=>(
                                    <tr key={i} className='table-row'>
                                       { /*<td id='id' className='table-cell' style={{width:'50px'}}>
                                        <div className='symbol symbol-45px me-2'>
                                        <span className='symbol-label'>
                                        {d.type ==="Problem Report" && <KTIcon iconName='bi bi-receipt-cutoff' className='text-pink fs-1' />}
                                        {d.type ==="Change Request" && <KTIcon iconName='bi bi-receipt-cutoff' className='text-azul fs-1' />}
                                        {d.type ==="Feature Request" && <KTIcon iconName='bi bi-receipt-cutoff' className='text-cian fs-1' />}
 
                                        </span>
                                        </div>
                                         </td>*/}
                                        <td className='table-cell'>
                                            {d.type ==="Incident Report" && <span className='badge badge-light-pink'>{d.type}</span>}
                                            {d.type ==="Change Request" && <span className='badge badge-light-azul'>{d.type}</span>}
                                            {d.type ==="Feature Request" && <span className='badge badge-light-marino'>{d.type}</span>}
                                            {d.type ==="Help Request" && <span className='badge badge-light-warning'>{d.type}</span>}
 
                                        </td>
                                       {d.id !== 0 && <td className='table-cell'>{d.id}</td>}
                                        <td className='table-cell'>{d.subject}</td>
                                       
                                       
                                        <td className='table-cell'>                              
                                        {d.status.label ==="This ticket has been Resolved" ?<span className='badge badge-light-success'>{d.status.label}</span>
                                        : d.status.label ==="Resolved" ?<span onMouseEnter={() => handleMouseEnter(d.status.label_for_customers,i)} onMouseLeave={handleMouseLeave} className='badge  badge-light-success'>{d.status.label}{showPopup && cellIndex===i && <Popup text={popupText} />}</span>
                                        :d.status.label ==="Completed" ?<span onMouseEnter={() => handleMouseEnter(d.status.label_for_customers,i)} onMouseLeave={handleMouseLeave} className='badge  badge-light-success'>{d.status.label}{showPopup && cellIndex===i && <Popup text={popupText} />}</span>
                                        :d.status.label ==="This ticket has been Closed" ? <span className='badge  badge-light-dark'>{d.status.label}</span>:
                                        d.status.label ==="Closed" ? <span onMouseEnter={() => handleMouseEnter(d.status.label_for_customers,i)} onMouseLeave={handleMouseLeave}className='badge  badge-light-dark'>{d.status.label}{showPopup && cellIndex===i && <Popup text={popupText} />} </span>
                                        :d.status.label ==="Canceled" ? <span onMouseEnter={() => handleMouseEnter(d.status.label_for_customers,i)} onMouseLeave={handleMouseLeave} className='badge  badge-light-danger'>{d.status.label}{showPopup && cellIndex===i && <Popup text={popupText} />}</span>
                                        :d.status.label ==="Declined" ?<span onMouseEnter={() => handleMouseEnter(d.status.label_for_customers,i)} onMouseLeave={handleMouseLeave} className='badge  badge-light-danger'>{d.status.label}{showPopup && cellIndex===i && <Popup text={popupText} />}</span>:
                                        <span onMouseEnter={() => handleMouseEnter(d.status.label_for_customers,i)} onMouseLeave={handleMouseLeave} className='badge  badge-light-primary'>{d.status.label} {showPopup && cellIndex===i && <Popup text={popupText} />}</span>  
                                        }
 
                                        </td>
                                        <td className='table-cell'>
                                            {typeof d.id === 'string' && (d.id.includes('CRE') || d.id.includes('TRE')) &&( d.priority === 1 || d.priority === 10000) ? <span className='badge badge-light-danger'>Urgent</span> : d.priority === 1 && <span className='badge badge-light-success'>Low</span>}
                                            {typeof d.id === 'string' && (d.id.includes('CRE') || d.id.includes('TRE')) && d.priority === 2 ? <span className='badge badge-light-orange'>High</span> : d.priority === 2 && <span className='badge badge-light-warning'>Medium</span>}
                                            {typeof d.id === 'string' && (d.id.includes('CRE') || d.id.includes('TRE')) && d.priority === 3 ? <span className='badge badge-light-warning'>Medium</span> : d.priority === 3 && <span className='badge badge-light-orange'>High</span>}
                                            {typeof d.id === 'string' && (d.id.includes('CRE') || d.id.includes('TRE')) && d.priority === 4 ? <span className='badge badge-light-success'>Low</span> : d.priority === 4 && <span className='badge badge-light-danger'>Urgent</span>}
                                        </td>
                                       {d.id !==0 && <td className='table-cell'>
                                            <button onClick={ () => setID(d.id)} className='btn-light-marino f-parrafo'> See Details </button>
                                        </td>}
                                    </tr>
                                ))
                            }
 
                        </tbody>
                          {/* end::Table body */}
 
                    </table>
                     {/* end::Table */}
                </div>
                <br />
         
            {/*****************PAGINACION*********************** */}                  
            <div className="pagination-container">
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        {records.length!==0&&<div className="d-flex align-items-center">
                            <label htmlFor="recordsPerPage" className="label-text me-2 mb-0 f-parrafo text-marino">Items per page:</label>
                            <select
                                id="recordsPerPage"
                                className="form-select"
                                value={recordsPerPage}
                                onChange={handleRecordsPerPageChange}
                                style={{width:'80px'}}
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">20</option>
                                {/* Agrega más opciones según sea necesario */}
                            </select>
                        </div>}
                    </div>
                    <div className="col-lg-8 col-md-6 col-sm-12 mt-3 mt-md-0">
                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-end">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={() => paginate(currentPage - 1)} aria-label="Previous">
                                        <span aria-hidden="true">&laquo;</span>
                                        <span className="sr-only">Previous</span>
                                    </button>
                                </li>
                                {Array.from({ length: Math.ceil(records.length / recordsPerPage) }).map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => paginate(index + 1)}>{index + 1}</button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === Math.ceil(records.length / recordsPerPage) ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={() => paginate(currentPage + 1)} aria-label="Next">
                                        <span aria-hidden="true">&raquo;</span>
                                        <span className="sr-only">Next</span>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
 
            </div>
            {/* end::Tap pane */}
            </div>
        </div>
        {/* end::Body */}
        </div>
        {ID !== undefined && <ViewModal setID={setID} id={ID} />}
        </>
 
    )
    }
 
export default TicketsCrud